export default __webpack_public_path__ + "static/media/Bjorn_N.fac29294.png";